﻿﻿﻿<contractitem-filter (outputFilter)="onFilter($event)" (switchActive)="onSwitchActive($event)"></contractitem-filter>
<contractitem-list [list]="activeFilteredList" [showLocalFilter] ="showLocalFilter" ></contractitem-list>